<template>
  <el-container class="document-info">
    <el-main>
      <div class="content-header">
        <img
          src="@assets/codeScan/code_scan_there.png"
          alt="Settings Icon"
          class="settings-icon"
        />
        <h2>{{ $t('document.documentation') }}</h2>
      </div>
      <div class="document-info-content">
        <Markdown
          :content="content"
          :products="products"
        />
      </div>
    </el-main>
  </el-container>
</template>

<script>
import Markdown from '@/components/mark-down';
import content from '@docs/docs/user-manual.md';

export default {
  name: 'DocumentInfo',
  components: {
    Markdown,
  },
  data() {
    return {
      content,
    };
  },

  computed: {
    products() {
      return {
        APP_TITLE: this.APP_TITLE,
        EXTENSION_NAME: this.EXTENSION_NAME,
        SUPPORT_EMAIL: this.SUPPORT_EMAIL,
        DISCORD_URL: this.DISCORD_URL,
      };
    },
  },
};
</script>

<style lang="scss">
.document-info {
  width: 100%;
  display: flex;
  background-color: #fff;
  border-radius: 10px;
  font-family: 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;

  .document-info-content {
    max-width: 960px;
    margin: 0 auto;
  }

  .content-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    background-color: #e1e8ed;
    border-radius: 10px;
    padding: 0px 20px;
    height: 55px;
    line-height: 54px;

    h2 {
      margin: 0;
      font-size: 20px;
      font-weight: 600;
    }

    img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
  }

  h1 {
    font-size: 32px;
    font-weight: 600;
  }

  blockquote {
    background: #f9f9f9;
    color: #666;
    border-left: 4px solid #ccc;
    padding: 10px 20px;
    margin: 10px 0;
    border-radius: 4px;
  }

  ul,
  ol {
    line-height: 1.5;
    margin: 0 0 0 20px;
    padding: 0;

    li::marker {
      color: #1456f0;
    }

    li:not(:last-child) {
      margin-bottom: 1em;
    }
  }

  img {
    max-width: 100%;
    height: auto;
  }

  pre {
    background: #f0f4ff;
    border: 1px solid #bacefd;
    padding: 10px 20px;
    margin: 10px 0 0 20px;
    border-radius: 4px;
    white-space: pre-wrap;
    word-wrap: break-word;

    &::first-line {
      font-weight: bold;
      color: #245bdb;
    }
  }
}
</style>